import api from "../api/flexapi";
import {
  NAVIGATION_MENU_REQUEST,
  NAVIGATION_MENU_SUCCESS,
  NAVIGATION_MENU_FAILURE,
  CLIENT_SETTINGS_REQUEST,
  CLIENT_SETTINGS_SUCCESS,
  CLIENT_SETTINGS_FAILURE,
  LOAD_CUSTOM_CSS_REQUEST,
  LOAD_CUSTOM_CSS_SUCCESS,
  LOAD_CUSTOM_CSS_FAILURE,
  LOAD_NEW_NAV_MENU_REQUEST,
  LOAD_NEW_NAV_MENU_SUCCESS,
  LOAD_NEW_NAV_MENU_FAILURE,
} from "../actions/commonActions";

import {
  GET_GLOBAL_MESSAGE_BOARD_SUCCESS,
  GET_GLOBAL_MESSAGE_BOARD_ERROR,
  HIDE_GLOBAL_MESSAGE_BOARD,
} from "../components/common/global-message-board/actions";

import { FETCH_USER_SUCCESS, FETCH_USER_PROXY_SUCCESS } from "../actions/loginActions";

import {
  MESSAGING_GET_UNREAD_COUNT_BEGIN,
  MESSAGING_GET_UNREAD_COUNT_SUCCESS,
  MESSAGING_GET_UNREAD_COUNT_ERROR,
} from "../actions/messagingActionTypes";

import lodash from "lodash";

const initialState = {
  menuItems: null,
  profileMenu: {},
  isFetching: false,
  isFetched: false,
  error: null,
  isEnrolmentEnabled: false,
  isShopEnabled: false,
  isExternalShopEnabled: false,
  isHraEnabled: false,
  logoUrl: null,
  faqLabel: null,
  faqUrl: null,
  clientSettings: null,
  settingsLoaded: false,
  settingsLoadingFailed: false,
  messaging: {},
  customCss: null,
  customCssError: false,
  globalMessageBoard: {},
};

// Determine whether features are enabled by matching IDs with menu items and their children
// This logic be replaced with explicit flags in APL-3041
const isMenuEnable = (menuItems, item) =>
  menuItems.filter(
    m => m.id === item || (m.children && m.children.filter(c => c.id === item).length > 0)
  ).length > 0;

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case NAVIGATION_MENU_REQUEST:
    case LOAD_NEW_NAV_MENU_REQUEST:
      return {
        ...state,
        isFetching: true,
        isFetched: false,
      };

    case NAVIGATION_MENU_SUCCESS:
      const isEnrolmentEnabled = isMenuEnable(
        action.payload.menu,
        "FlexBenefitsMain_BenefitsEnrolment"
      );

      // If enrolment is enabled for employee, trigger the caching of enrolment data to make sure that
      // cache is available by the time user navigates to enrolment page.
      if (isEnrolmentEnabled) {
        api.cacheEnrolment();
      }

      return {
        ...state,
        menuItems: action.payload.menu,
        profileMenu: action.payload.employeeProfileMenu,
        isFetching: false,
        isFetched: true,
        isEnrolmentEnabled: isEnrolmentEnabled,
        isShopEnabled: isMenuEnable(action.payload.menu, "FlexBenefitsMain_eCommerce"),
        isExternalShopEnabled: isMenuEnable(action.payload.menu, "CXAShopMain_CXAShop"),
        isHraEnabled: isMenuEnable(action.payload.menu, "HealthAndWellnessMain_Aging"),
        messaging: {
          ...state.messaging,
          menu: { ...action.payload.messagingMenu },
        },
      };

    case LOAD_NEW_NAV_MENU_SUCCESS:
      return {
        ...state,
        menuItems: [...action.payload.menus],
        profileMenu: action.payload.profileMenu,
        // new menu Benefits Selection id: FlexBenefitsMain, old menu Benefits Selection id:FlexBenefitsMain_BenefitsEnrolment
        isEnrolmentEnabled: isMenuEnable(action.payload.menus, "FlexBenefitsMain"),
        isShopEnabled: isMenuEnable(action.payload.menus, "FlexBenefitsMain_eCommerce"),
        isExternalShopEnabled: isMenuEnable(action.payload.menus, "CXAShopMain_CXAShop"),
        isHraEnabled: isMenuEnable(action.payload.menus, "HealthAndWellnessMain_Aging"),
        isFetching: false,
        isFetched: true,
        messaging: {
          ...state.messaging,
          menu: { ...action.payload.messagingMenu },
        },
      };

    case NAVIGATION_MENU_FAILURE:
    case LOAD_NEW_NAV_MENU_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        error: action.payload,
      };
    // TODO: Do this the proper way

    case CLIENT_SETTINGS_REQUEST:
      return {
        ...state,
      };

    case CLIENT_SETTINGS_SUCCESS:
      return {
        ...state,
        logoUrl: lodash.get(action.payload, "logo", null),
        faqLabel: lodash.get(action.payload, "faqLabel", null),
        faqUrl: lodash.get(action.payload, "faqUrl", null),
        clientSettings: action.payload,
        settingsLoaded: true,
        settingsLoadingFailed: false,
      };

    case CLIENT_SETTINGS_FAILURE:
      return {
        ...state,
        settingsLoaded: false,
        settingsLoadingFailed: true,
      };

    // Load subsidiary logo on login if available
    case FETCH_USER_SUCCESS:
    case FETCH_USER_PROXY_SUCCESS:
      return {
        ...state,
        logoUrl: action.payload.subsidiaryLogo || state.logoUrl,
      };

    case LOAD_CUSTOM_CSS_REQUEST:
      return {
        ...state,
      };

    case LOAD_CUSTOM_CSS_SUCCESS:
      return {
        ...state,
        customCss: action.payload,
        customCssError: false,
      };

    case LOAD_CUSTOM_CSS_FAILURE:
      return {
        ...state,
        customCss: null,
        customCssError: true,
      };

    case MESSAGING_GET_UNREAD_COUNT_BEGIN:
      return {
        ...state,
        isFetching: true,
        isFetched: false,
      };

    case MESSAGING_GET_UNREAD_COUNT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        messaging: {
          ...state.messaging,
          unreadMessageCount: action.payload.unreadMessageCount,
        },
      };

    case MESSAGING_GET_UNREAD_COUNT_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        error: action.payload,
      };

    case GET_GLOBAL_MESSAGE_BOARD_SUCCESS:
      return {
        ...state,
        globalMessageBoard: action.payload,
      };
    case GET_GLOBAL_MESSAGE_BOARD_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case HIDE_GLOBAL_MESSAGE_BOARD:
      return {
        ...state,
        globalMessageBoard: { ...state.globalMessageBoard, ...action.payload },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/commonReducer.jsx